import { render, staticRenderFns } from "./SortableHeaderElement.vue?vue&type=template&id=38296f01&"
import script from "./SortableHeaderElement.vue?vue&type=script&lang=js&"
export * from "./SortableHeaderElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports